<template>
<v-text-field outlined v-model="name" :rules="rulesName" :label="labelName" counter :maxlength="maxlength" :autofocus="autofocus"></v-text-field>
</template>

<script>
export default {
  name: 'NameTextField',
  props: {
    value: {
      type: String
    },
    maxlength: {
      type: Number,
      default: 25
    },
    label: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array
    },
    autofocus:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    name: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    labelName() {
      return this.label || this.$t('name.name')
    },
    rulesName() {
      let r = [];
      if (this.required) {
        r.push(v => !!v || this.$t('name.name_is_required'));
      }
      if (this.rules) {
        this.rules.forEach(val => r.push(val));
      }
      return r;
    }
  }
}
</script>
